import Component from "flarum/common/Component";
import dayjs from "dayjs";
import { urls } from '@speareducation/util';
import { isMobileWebview, getMobileOS } from "../../util";

export default class Banner extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.userAgent = getMobileOS();

    setTimeout(() => {
      this.isShowing = this.shouldShowBanner();
    }, 1000);
  }

  view() {
    const { className } = this.attrs;
    const showIos = this.userAgent === "iOS";
    const showAndroid = this.userAgent === "Android";
    const showBoth = this.userAgent === "Other";

    if (isMobileWebview() || window.innerWidth > 768) return;

    return (
      <div className={`Banner ${className} ${this.isShowing ? "active" : ""}`}>
        <div className="Banner-main">
          <button
              className="Button Button--link x-button"
              onclick={this.dismiss.bind(this)}
            >
              <i className="fa fa-times" />
          </button>

          <div className="Banner-all">
            <div className="Banner-img">
              <img 
                src={`${urls.getAssetsBaseUrl()}/icons/spear_talk_mobile.png`}
                alt="Spear Talk App"
                className="Banner-img"
              />
            </div>

            <div className="Banner-text">
              <h3>
                Take the Spear Community with you anywhere you go with the NEW Spear Talk app
              </h3>
              <p>
                Don't navigate dentistry alone, download today!
              </p>
            </div>
          </div>

          <div className="Banner-actions">
            <div className="Banner-buttons">
              {showBoth && (
                <>
                    {this.iOSButton()}
                    {this.androidButton()}
                </>
              )}

              {showIos && (
                <>
                  {this.iOSButton()}
                </>
              )}

              {showAndroid && (
                <>
                  {this.androidButton()}
                </>
              )}

              <p className="Banner-available-on">App available on phone or tablet, for iOS and Android.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  iOSButton() {
    return (
      <a
        href="https://apps.apple.com/us/app/spear-talk/id6468835677"
        target="_blank"
        rel="noreferrer"
        className="OS-link"
        onclick={this.dismiss.bind(this)}
      >
        <div className="OS-link-main apple">
          <img
              src={`${urls.getAssetsBaseUrl()}/icons/apple_logo.svg`}
              alt="Apple App Store"
              className="app-store-badge"
          />
          <span className="download-text"><span className="download-start">Download on the</span> <br /> <span className="OS-store">App Store</span></span>
        </div>
      </a>
    );
  }  

  androidButton() {
    return (
      <a
        href="https://play.google.com/store/apps/details?id=com.speareducation.spear_talk&pli=1"
        target="_blank"
        rel="noreferrer"
        className="OS-link"
        onclick={this.dismiss.bind(this)}
      >
        <div className="OS-link-main">
          <img 
              src={`${urls.getAssetsBaseUrl()}/icons/Play_Store_logo.webp`}
              alt="Google Play Store"
              className="play-store-badge"
          />
          <span className="download-text"><span className="download-start">GET IT ON</span> <br /> <span className="OS-store">Google Play</span></span>
        </div>
      </a>
    );
  }

  dismiss() {
    localStorage.setItem("dismissedBanner", new Date().toISOString());
    this.isShowing = false;
  }

  shouldShowBanner() {
    const dismissedBanner = localStorage.getItem("dismissedBanner");
    if (!dismissedBanner) return true;

    const now = dayjs();
    const dismissed = dayjs(dismissedBanner);
    return now.diff(dismissed, "minute") >= 59;
  }
}
